module.exports = {
      id: "twitter-icon-usage",
      viewBox: "0 0 135.08 135.08",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#twitter-icon",
      toString: function () {
        return this.url;
      }
    }